@if (isGprmAud()) {
<div>
  <h3>GRPM</h3>
  <a
    href="https://outlook.office365.com/ecp/MyGroups/EditDistributionGroup.aspx?id=bd216175-80a2-4d85-988a-742cf336f57a"
    target="blank"
    >GPRM Auditees</a
  ><br />
  <a
    href="https://outlook.office365.com/ecp/MyGroups/EditDistributionGroup.aspx?id=219ee5a5-984b-48b2-9a3d-f93ad413305f"
    target="blank"
    >GPRM Readers</a
  ><br />
</div>
} @if (isGpiaAud()) {
<div>
  <h3>GPIA</h3>
  <a
    href="https://outlook.office365.com/ecp/MyGroups/EditDistributionGroup.aspx?id=92cb1cfc-7a18-4301-96b8-4f4dcbbbb1cc"
    target="blank"
    >GPIA Auditees</a
  ><br />
  <a
    href="https://outlook.office365.com/ecp/MyGroups/EditDistributionGroup.aspx?id=f8dfbd3a-0230-46b4-9c20-aa3029dc009e"
    target="blank"
    >GPIA BGASIA</a
  ><br />
  <a
    href="https://outlook.office365.com/ecp/MyGroups/EditDistributionGroup.aspx?id=9c2ba9e3-8392-4d4c-8ded-9ac2a1bbb088"
    target="blank"
    >GPIA BGEU</a
  ><br />
  <a
    href="https://outlook.office365.com/ecp/MyGroups/EditDistributionGroup.aspx?&id=8c10d27f-d9e6-4a81-be7e-2a369fb8c74d"
    target="blank"
    >GPIA BGNA</a
  ><br />
  <a
    href="https://outlook.office365.com/ecp/MyGroups/EditDistributionGroup.aspx?id=45cb310f-7e39-4272-a444-7c753f388ab6"
    target="blank"
    >GPIA BGSAMEA</a
  ><br />
</div>
}
